export const heroContent = {
  en: {
    title: {
        line1: "Expert Care,",
        line2: "Anytime, Anywhere",
    },

    subtitle:
      "Do professionaly designed physiotherapy sessions from the comfort of your home...",
    getStarted: "Get Started Free",
    book: "Book a Session",
  },
  sl: {
    title: {
      line1:"Strokovna oskrba,",
      line2: "kadarkoli in kjerkoli.",},
    subtitle:
      "Začnite s profesionalno fizijoterapio iz udobja svojega doma ...",
    getStarted: "Začnite brezplačno",
    book: "Rezervirajte termin",
  },
} as const;
